import type { ReactNode } from "react";
import { BrowserRouter } from "react-router";
import { AppContext, type AppContainer } from "./container";
import { LocaleProvider } from "./i18n/LocaleProvider";
import { AppRoutes } from "./routes";
import { ThemeProvider } from "./theme/ThemeProvider";

export function AppProviders({ container, children }: { container: AppContainer; children: ReactNode }) {
  return (
    <AppContext.Provider value={container}>
      <LocaleProvider>
        <ThemeProvider>{children}</ThemeProvider>
      </LocaleProvider>
    </AppContext.Provider>
  );
}

export function App({ container }: { container: AppContainer }) {
  return (
    <AppProviders container={container}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AppProviders>
  );
}
